module.exports = "data:application/x-font-ttf;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICI5NDk5ODQ3NWY2YWVhNjVmNTU4NDk0ODAyNDE2YzFjZi50dGYiOw=="


//////////////////
// WEBPACK FOOTER
// ../~/materialize-css/fonts/roboto/Roboto-Thin.ttf
// module id = 446
// module chunks = 0